import React from 'react';
import Modal from "../Modal";
import useStyles from "./style";
var Loading = function Loading(_ref) {
  var open = _ref.open,
    _ref$content = _ref.content,
    content = _ref$content === void 0 ? 'loading...' : _ref$content,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 240 : _ref$width;
  var _useStyles = useStyles(),
    styles = _useStyles.styles,
    prefixCls = _useStyles.prefixCls;
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    width: width,
    closable: false,
    footer: null,
    className: prefixCls + '-loading',
    centered: true
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.loadingWrap
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.loadingInner
  }, content)));
};
export default Loading;